import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CommonFlowCard, CommonFlowCardProps } from '@/lib/v3/components';

import { CREATED, UPDATED } from '@/modules/AutomationModuleNew/constants/flows';
import { FilterData } from '@/modules/AutomationModuleNew/types/flowsTypes';

export interface FilterCardProps extends CommonFlowCardProps {
  data: FilterData;
}

const FilterCard = (props: FilterCardProps) => {
  const { data } = props;
  const { t } = useTranslation();

  const info = useMemo(() => {
    const { value } = data.input.condition.leftValue;
    if (value === undefined) return undefined;

    return t('FilterCard.integration.info', {
      value: value ? t(CREATED) : t(UPDATED),
    });
  }, [data.input.condition.leftValue, t]);
  return <CommonFlowCard {...props} info={info} />;
};

export default memo(FilterCard);
